import { Component, ViewChild } from '@angular/core';
import { SearchBarComponent } from '../../../search-bar/search-bar.component.js';
import { SelfUpdateMode } from '../../company-update.interface.js';
import { CompanyUpdateService } from '../../services/company-update.service.js';
import { Router } from '@angular/router';
import { ComponentBase } from '@Common';
import { DeploymentContext } from '@Common';
import { AuthnService } from '@Common';
@Component({
	selector: 'update-header',
	templateUrl: './update-header.component.html',
	styleUrls: ['./update-header.component.scss'],
	standalone: false,
})
export class UpdateHeaderComponent extends ComponentBase {
	public get selfUpdateMode(): SelfUpdateMode {
		return this._companyUpdateService.selfUpdateMode;
	}
	public SelfUpdateModes = SelfUpdateMode;

	@ViewChild(SearchBarComponent)
	public searchBar: SearchBarComponent;

	constructor(
		dc: DeploymentContext,
		private _router: Router,
		private _authnService: AuthnService,
		private _companyUpdateService: CompanyUpdateService
	) {
		super(dc);
	}

	public goHome(): void {
		this._router.navigate(['/']);
	}

	public get userId(): string {
		return this._authnService.userId;
	}
}
